import { isClarifyChipKey } from '@/constants/intakeClarifyChips.ts';

/** Maps stored chip keys (chipMarket,chipOther) to intake clarify labels for display. */
export function formatConstraintSummary(
  summary: string,
  translateChip: (chipKey: string) => string,
): string {
  const trimmed = summary.trim();
  if (!trimmed) return '—';

  const [chipPart, ...detailParts] = trimmed.split(' — ');
  const detail = detailParts.join(' — ').trim();

  const labels = chipPart
    .split(',')
    .map((token) => token.trim())
    .filter(Boolean)
    .map((token) => (isClarifyChipKey(token) ? translateChip(token) : token));

  const formatted = labels.join(', ');
  if (detail) return `${formatted} — ${detail}`;
  return formatted || trimmed;
}
